import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  SelectChangeEvent,
} from "@mui/material";
import { CancelButton, ConfirmButton } from "../MuiConfirmationModal/styled";
import { GfUnit } from "@swagger/typescript-fetch-goflyer";

interface Props {
  open: boolean;
  unitList: GfUnit[];
  handleCancel?: () => void;
  handleConfirm?: (replacementUnitId: string) => void;
  title?: string;
  description?: string | React.ReactNode;
}

export function MuiConfirmationModalUnit({
  open,
  unitList,
  handleCancel,
  handleConfirm,
  title,
  description,
}: Props) {
  const { t } = useTranslation();
  const [selectedUnit, setSelectedUnit] = React.useState<string>("");

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    setSelectedUnit(event.target.value);
  };
  const handleConfirmClick = () => {
    if (handleConfirm && selectedUnit) {
      handleConfirm(selectedUnit);
    }
  };

  return (
    <div data-testid="muiconfirmationmodal-test-id">
      <Dialog
        open={open}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {description}
          </DialogContentText>
          <FormControl
            fullWidth
            margin="normal"
            sx={{
              "& .MuiInputLabel-root": { color: "#f58220" },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#f58220",
                  color: "#f58220",
                },
                "&:hover fieldset": {
                  borderColor: "#f58220",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#f58220",
                },
              },
            }}
          >
            <InputLabel id="replacement-unit-label">
              {t(messages.Unit())}
            </InputLabel>
            <Select
              labelId="replacement-unit-label"
              value={selectedUnit}
              onChange={handleSelectChange}
              data-testid="replacement-unit-dropdown"
              label={t(messages.Unit()) as string}
            >
              {unitList.map((unit) => (
                <MenuItem key={unit.id} value={unit.id}>
                  {unit.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={handleCancel}>
            {t(messages.Cancel())}
          </CancelButton>
          <ConfirmButton
            data-testid="confirm-button"
            onClick={handleConfirmClick}
            disabled={!selectedUnit}
            autoFocus
          >
            {t(messages.Confirm())}
          </ConfirmButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
